﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';
import KWRadio from '@/controls/kw.radio';

export default class KWSubmitDirect extends TKCustomElementFactory {
    attr?: string;
    requestURL?: string;
    forceReload: boolean;
    noInitSubmit: boolean;
    isInit: boolean;

    constructor() {
        super();

        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.forceReload = this.hasAttribute('data-tk-force-reload');
        this.noInitSubmit = this.hasAttribute('data-tk-no-init-submit');
        this.isInit = true;
    }

    connectedCallback(): void {
        if (!this.requestURL) return;

        this.registerListener();
    }

    registerListener():void {
        const radioElement = this.querySelector('kw-radio') as KWRadio || undefined;
        if (radioElement) {
            const action = this.submitField.bind(this, radioElement, false);
            radioElement.radios.forEach((element) => this.pushListener({ event: 'click', element, action }));

            this.submitField(radioElement, true); // execute on callback
        } else {
            const formField = this.querySelector('select') || this.querySelector('input')
            || this.querySelector('textarea') || undefined;

            if (formField) {
                const action = this.submitField.bind(this, formField, false);
                this.pushListener({ event: 'blur', element: formField, action });

                this.submitField(formField, true);
            }
        }
    }

    submitField(element: (KWRadio | HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement), init:boolean) {
        if (this.isInit) {
            this.isInit = false;
            if (this.noInitSubmit) return;
        }

        const isRadio = !!(element instanceof KWRadio);

        const value = isRadio
            ? element.getSelectedValue()
            : element.value;

        const data = {
            attr: this.attr,
            value,
        };

        fetchRequest({
            requestURL: this.requestURL!,
            resolveHandler: this.refreshContent.bind(this, init),
            payload: data,
        });
    }

    refreshContent(init:boolean) {
        if (init || !this.forceReload) return;

        const container = document.querySelector('[data-tk-container]') as HTMLElement | undefined;
        const requestURL = container?.getAttribute('data-tk-content-url');

        if (!container || !requestURL) return;

        fetchRequest({
            requestURL,
            resolveHandler: this.replaceContent.bind(this, container),
        });
    }

    // eslint-disable-next-line class-methods-use-this
    replaceContent(container:HTMLElement, response:TKResponse):void {
        const body = render(response.dataAsHtml, true);
        container.replaceChildren(body);
        const newTotal = container.querySelector('[data-tk-checkout-total]')?.innerHTML;
        const footerTotal = document.querySelector('[data-op-asyncbasket]');
        if (!newTotal || !footerTotal) return;
        footerTotal.innerHTML = newTotal;
    }
}